import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>WEB DEVELOPER</h3>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/videos">Vlog</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>PATH OF EXILE 2</h3>
          <ul>
            <li><Link to="/">PoE 2 Skills AI</Link></li>
            <li><Link to="/poe2skilltreeplanner">PoE2 Skill Tree Planner</Link></li>
            <li><Link to="/poe2skillplanner">PoE2 Skills Planner</Link></li>
            <li><Link to="/skills">PoE 2 Skill Gems</Link></li>
            <li><Link to="/supports">PoE 2 Support Gems</Link></li>
            <li><Link to="/spirits">PoE 2 Spirit Gems</Link></li>
            <li><Link to="/articles">PoE 2 Articles</Link></li>
            <li><Link to="/videos">PoE 2 Vlog</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>MY OTHER WEBSITES</h3>
          <ul>
            <li><a href="https://www.chillguyclicker.us/" >Chill Guy Clicker</a> </li>
            <li><a href="https://www.cutecoloringpages.app/" >Cute Coloring Pages</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>LEGAL</h3>
          <ul>
            <li><Link to="/Legal">Legal</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}; 